$(document).ready(function(){
    needAuth();
});

$('.s-title').click(function(e) {
    e.preventDefault();
    $(this).next('.s-desc').slideToggle();
    $(this).toggleClass('active');
});

var $page = $('html, body');
$('.page-links a').click(function() {
    $page.animate({
        scrollTop: $($.attr(this, 'href')).offset().top
    }, 400);
    return false;
});

$('.show-all-ev').click(function() {
    $('.ev-item').removeClass('ev-item-hidden');
    $('.ev-item').removeClass('item-last');
});

$('.g-btn').click(function() {
    $(this).addClass('gt-item-selected');
    $('.pr-btn').removeClass('gt-item-selected');
    $('.prcy-block').hide();
    $('.google-block').show();
});
$('.pr-btn').click(function() {
    $(this).addClass('gt-item-selected');
    $('.g-btn').removeClass('gt-item-selected');
    $('.prcy-block').show();
    $('.google-block').hide();
});
$('.yt-btn').click(function() {
    $(this).addClass('yt-item-selected');
    $('.goo-btn').removeClass('yt-item-selected');
    $('.search-yandex').show();
    $('.search-google').hide();
});
$('.goo-btn').click(function() {
    $(this).addClass('yt-item-selected');
    $('.yt-btn').removeClass('yt-item-selected');
    $('.search-google').show();
    $('.search-yandex').hide();
});

$('.new-links').click(function() {
    let newLinksTable = $('.new-links-table');
    let bestLinksTable = $('.best-links-table');
    let citedLinksTable = $('.cited-links-table');
    $(this).addClass('active');
    $('.best-links').removeClass('active');
    $('.cited-links').removeClass('active');

    newLinksTable.addClass('active');
    bestLinksTable.removeClass('active');
    citedLinksTable.removeClass('active');

    newLinksTable.show();
    bestLinksTable.hide();
    citedLinksTable.hide();

    return false;
});

$('.best-links').click(function() {
    let newLinksTable = $('.new-links-table');
    let bestLinksTable = $('.best-links-table');
    let citedLinksTable = $('.cited-links-table');
    $(this).addClass('active');
    $('.new-links').removeClass('active');
    $('.cited-links').removeClass('active');

    bestLinksTable.addClass('active');
    newLinksTable.removeClass('active');
    citedLinksTable.removeClass('active');

    bestLinksTable.show();
    newLinksTable.hide();
    citedLinksTable.hide();

    return false;
});

$('.cited-links').click(function() {
    let newLinksTable = $('.new-links-table');
    let bestLinksTable = $('.best-links-table');
    let citedLinksTable = $('.cited-links-table');
    $(this).addClass('active');
    $('.new-links').removeClass('active');
    $('.best-links').removeClass('active');

    citedLinksTable.addClass('active');
    bestLinksTable.removeClass('active');
    newLinksTable.removeClass('active');

    citedLinksTable.show();
    bestLinksTable.hide();
    newLinksTable.hide();

    return false;
});

$('.new-links').click(function() {
    let newLinksTable = $('.new-links-table');
    let bestLinksTable = $('.best-links-table');
    let citedLinksTable = $('.cited-links-table');
    $(this).addClass('active');
    $('.best-links').removeClass('active');
    $('.cited-links').removeClass('active');

    newLinksTable.addClass('active');
    bestLinksTable.removeClass('active');
    citedLinksTable.removeClass('active');

    newLinksTable.show();
    bestLinksTable.hide();
    citedLinksTable.hide();
});

$(".g-btns div").click(function() {

    var id = $(this).attr('data-graf');

    $(".g-cont").hide();

    $(".g-btns div").removeClass('active');

    $(".g-btns div[data-graf="+id+"]").addClass('active');

    $(".g-cont[data-graf="+id+"]").show();

});

$('.open-info').click(function() {
    $(this).parent('.row-img').parent('.table-row').next('.hidden-info').slideToggle();
});

$('.log a').on('click', function () {
    $(this).find('.no-hover').hide();
    $(this).find('.click').show();
});

$('.request-meet').on('click', function () {
    $('.request-meet-input-topic').val($(this).text());
    $('.request-meet-sent-title').text($(this).data('title'));

    let reachGoal = $(this).data('ya-goal');
    let counter = $(this).data('ya-counter');
    if (reachGoal !== undefined && counter !== undefined) {
        $('.btn-request-meet').attr('onclick', "ym(" + counter + ", 'reachGoal', '" + reachGoal + "'); return true;");
    } else {
        $('.btn-request-meet').removeAttr('onclick');
    }
});

function phoneMask(el) {
    let dispatchMask = IMask(el, {
            mask: [
                {
                    mask: '{+}00 {21} 0 000 0000',
                    startsWith: '30',
                    lazy: false,
                    country: 'Greece'
                },
                {
                    mask: '{+}0 000 000-00-00',
                    startsWith: '7',
                    lazy: false,
                    country: 'Russia'
                },
                {
                    mask: '0 000 000-00-00',
                    startsWith: '8',
                    lazy: false,
                    country: 'Russia'
                },
                {
                    mask: '{+}00-0000-000000',
                    startsWith: '90',
                    lazy: false,
                    country: 'India'
                },
                {
                    mask: '{+}00000000000000000000',
                    startsWith: '',
                    country: 'unknown'
                }
            ],
            dispatch: function (appended, dynamicMasked) {
                let number = (dynamicMasked.value + appended).replace(/\D/g,'');

                return dynamicMasked.compiledMasks.find(function (m) {
                    return number.indexOf(m.startsWith) === 0;
                });
            }
        }
    )
}

function auth(el) {
    let form = $(el).parent('form');
    $.ajax({
        data: form.serialize(),
        url: form.attr('action'),
        type: 'POST',
        dataType: 'json',
        success: function(res) {
            if (!$.isEmptyObject(res)) {
                $.each(res, function (el, val) {
                    let invalidFeedback = form.find('.'+ el).find('.invalid-feedback');
                    invalidFeedback.text(val);
                    invalidFeedback.css('display', 'block');
                });
            } else {
                form.submit();
            }
        },
        error: function (res) {
            console.error(res);
        }
    });
}

function sendSms(el) {
    let btn = $(el);
    let form = btn.closest('form.need-verify-phone');
    let inputPhone  = form.find('input.phone-input');
    send('/phone-check-create-code', form, btn);
}

function send(url, form, btn) {
    let btnText = btn.text();

    $.ajax({
        data: form.serialize(),
        url: url,
        type: 'POST',
        dataType: 'json',
        success: function(res) {
            if (!$.isEmptyObject(res['errors'])) {
                $.each(res['errors'], function (el, val) {
                    let error = form.find('.'+ el).find('.invalid-feedback');
                    error.text(val);
                    error.css('display', 'block');
                });
            } else {
                let seconds = 60 - res['data']['timeout'];
                timer(btn, seconds, btnText);
            }
        }
    });
}

function timer(el, seconds, text) {
    let timerText = $(el).siblings('.timer');
    let interval = setInterval(function() {
        if (seconds > 0) {
            timerText.css('display', 'block');
            timerText.text('Повторный запрос через ' + seconds + ' сек.');
            el.prop('disabled', true);
            seconds--;
        } else {
            clearInterval(interval);
            timerText.css('display', 'none');
            timerText.text('');
            el.prop('disabled', false);
        }
    }, 1000);
}

function needAuth() {
    $('.need-auth').on('click', function () {
        return showAuth($(this).attr('href'));
    });
}

function showAuth(url) {
    let authModal = $('#auth-modal');
    if (authModal.length !== 0) {
        authModal.modal('show');
        $(authModal).find('input.url').val(url);
        return false;
    }
    return true;
}